import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import DeleteOutlined from '@ant-design/icons/DeleteOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';

const icons = {
  TeamOutlined,
  DatabaseOutlined,
  DeleteOutlined
};

// requiredRole — Navigation 이 useAuth().hasRole() 로 체크. 보유자에게만 노출.
const admin = {
  id: 'group-admin',
  title: '관리',
  type: 'group',
  requiredRole: 'admin',
  children: [
    {
      id: 'admin-users',
      title: '사용자 관리',
      type: 'item',
      url: '/admin/users',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-master',
      title: '마스터 관리',
      type: 'item',
      url: '/admin/master',
      icon: icons.DatabaseOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-storage',
      title: '저장공간 정리',
      type: 'item',
      url: '/admin/storage',
      icon: icons.DeleteOutlined,
      breadcrumbs: false
    }
  ]
};

export default admin;
